
import qs from 'qs';
import BaseHttp from '@/plugins/baseHttp';
import BaseFormat from '@/plugins/baseFormat';
import banksData from '../_json/bancos.json';

/**
 * @deprecated Since new franchise list feature. Use getAll instead.
 */
const get = (
  { _id, page, name, operation_stage, mode, state, published, sort, sortBy, },
) => {
  const offset = ((page || 1) - 1) * 15;
  const sortStrings = BaseFormat.sortString(sort, sortBy,);
  let stageString = '';

  if (_id) {
    return BaseHttp.get(`/franchises/${_id}?detail=true`,);
  }
  if (operation_stage) {stageString = operation_stage.join();}

  const queryObj = {
    name: name ? `/${name}/i` : undefined,
    operation_stage: stageString ? stageString : undefined,
    mode: mode ? mode : undefined,
    'franchise_address.state': state && (typeof state === 'string' || state instanceof String) ? state : undefined,
    published: published,
    fields: 'name,franchise_address.city,franchise_address.state,responsible.name,mode,operation_stage,published,cities_served,type,publish_status',
    sort: !Array.isArray(sortStrings,) ? sortStrings :
      sortStrings.join(',',) ||
      undefined,
    limit: '15',
    offset: offset || undefined,
  };
  const query = `/franchises${qs.stringify(
    queryObj,
    { addQueryPrefix: true, },
  )}`;

  return BaseHttp.get(
    query,
  );
};

const getAll = (filters,) => {

  const {
    name,
    consultant,
    operating_model,
    operation_stage,
    city,
    published,
    publish_status,
    page,
    limit,
    sort,
    sortBy,
  } = filters;

  const offset = ((page || 1) - 1) * (limit || 15);

  const query = {
    name,
    consultant,
    operation_stage,
    operating_model,
    'franchise_address.city': city && city.length ?
      city.map((selectedCity,) => selectedCity?.name || selectedCity,).join(',',) :
      undefined,
    published,
    publish_status,
    fields: '_id,name,consultant,franchise_address.city,franchise_address.state,responsible.name,mode,operation_stage,operating_model,published,cities_served,type,publish_status',
    sort: `${sort == 'desc'? '-': ''}${sortBy}`,
    limit: limit || '15',
    offset: offset || undefined,
  };

  const qsConfig = qs.stringify(
    query,
    { addQueryPrefix: true, },
  );

  return BaseHttp.get(`/franchises${qsConfig}`,);

};

const getCities = ({ franchises, page, search, size, from, },) => {
  size = size || 15;
  if (typeof from === 'undefined') {
    from = ((page || 1) - 1) * size;
  }

  const queryObj = {
    size: size,
    from: from,
    search: search ? `${search}` : undefined,
  };

  const query = `/address/cities/franchises?id=${franchises}&${qs.stringify(queryObj,)}`;

  return BaseHttp.get(query,);
};

const getUserFranchises = (limit,) => {
  return BaseHttp.get(`/users/franchises?limit=${limit}`,);
};

const getManagers = () => {
  return BaseHttp.get('/users/franchisor',);
};

const getBanks = () => {
  return new Promise((resolve,) => {
    setTimeout(() => {
      resolve(banksData,);
    }, 10,);
  },);
};

const removeAttachment = (franchiseId, attachmentId,) => {
  return BaseHttp.delete(`/franchises/${franchiseId}/attachments/${attachmentId}`,);
};

const postAttachment = (franchiseId, body,) => {
  return BaseHttp.post(`/franchises/${franchiseId}/attachments`, body,);
};

const post = (franchise,) => {
  return BaseHttp.post('/franchises', franchise,);
};

const patch = (franchiseId, body,) => {
  return BaseHttp.patch(`/franchises/${franchiseId}`, body,);
};

const getMarketplaceFranchises = ({ cnpj, },) => {
  return BaseHttp.get(`/marketplace/franchises?cnpj=${cnpj}`,);
};

const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};

const operationEditFranchises = (body,) => {
  return BaseHttp.patch('/operation-franchises/update', body,);
};

export default {
  get,
  getAll,
  getCities,
  post,
  patch,
  getManagers,
  getBanks,
  getUserFranchises,
  getMarketplaceFranchises,
  removeAttachment,
  postAttachment,
  handleError,
  operationEditFranchises,
};
